import { render } from "./purchaseHistoryTable.vue?vue&type=template&id=0a110697"
import script from "./purchaseHistoryTable.vue?vue&type=script&lang=js"
export * from "./purchaseHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__